import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const TableContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.lg')};
`;
